import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  description
}: ToggleProps) {
  return <div className="flex items-center justify-between" data-id="element-186">
      {(label || description) && <div className="mr-4" data-id="element-187">
          {label && <div className="text-sm font-medium text-white" data-id="element-188">{label}</div>}
          {description && <div className="text-xs text-text-muted mt-0.5" data-id="element-189">{description}</div>}
        </div>}
      <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} className={`
          relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-slate-900
          ${checked ? 'bg-primary' : 'bg-slate-700'}
        `} data-id="element-190">
        <span className={`
            pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `} data-id="element-191" />
      </button>
    </div>;
}